module.exports = __webpack_public_path__ + "img/Rookie-6.dc5b3ea9.png";